import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'breakLine'
})
export class BreakLinePipe implements PipeTransform {

  transform(text: string, shouldBreakLimit: number | null): string {
    if (text && shouldBreakLimit && text.length < shouldBreakLimit) {
      const lastSpaceIndex = text.lastIndexOf(' ');
      if (lastSpaceIndex !== -1) {
        return text.slice(0, lastSpaceIndex) + '<br>' + text.slice(lastSpaceIndex + 1);
      }
    }
    
    return text;
  }

}
